export const userTypes = {
  SET_USER_CHANNELS: "SET_USER_CHANNELS",
  LOAD_AGENT: "LOAD_AGENT",
  SET_AGENT_INFO: "SET_AGENT_INFO",
  SET_AGENTS: "SET_AGENTS",

  SET_CONTAINER_INFO: "SET_CONTAINER_INFO",
  SET_CONVERSATIONS_CHARGE: "SET_CONVERSATIONS_CHARGE",

  POST_USER_DATA_OF_OTP: "POST_USER_DATA_OF_OTP",
  POST_USER_DATA_OF_OTP_SUCCESS: "POST_USER_DATA_OF_OTP_SUCCESS",
  POST_USER_DATA_OF_OTP_FAILURE: "POST_USER_DATA_OF_OTP_FAILURE",
  LOGIN_USER_ONE_TIME_VERIFICATION: "LOGIN_USER_ONE_TIME_VERIFICATION",
};
